module.exports = __webpack_public_path__ + "img/24.a96fc4d2.png";